import { render, staticRenderFns } from "./Cloth1.vue?vue&type=template&id=29253903&scoped=true&"
import script from "./Cloth1.vue?vue&type=script&lang=js&"
export * from "./Cloth1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29253903",
  null
  
)

export default component.exports